import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

import type { useNavigationBase } from '@/hooks/useNavigationBase';

export const NavigationContext = createContext<ReturnType<typeof useNavigationBase> | null>(null);

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};
